import { ArrowRight } from "lucide-react";

export const BuildDayFinalCTA = () => {
  return (
    <section
      id="final-cta-buildday"
      data-testid="buildday-final-cta-section"
      className="relative bg-[#08090C] py-32 md:py-48 overflow-hidden border-t border-zinc-800"
    >
      {/* Blue glow + grain */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-60"
        style={{
          background:
            "radial-gradient(circle at 50% 60%, rgba(79,124,255,0.15), transparent 65%)",
        }}
      />
      <div className="absolute inset-0 grain" />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <div className="reveal flex items-center justify-center gap-3 mb-8">
          <span className="h-px w-10 bg-[#FCD34D]" />
          <span className="text-xs tracking-[0.3em] uppercase text-[#FCD34D] font-bold">
            The Builders Sprint · Limited Spots
          </span>
          <span className="h-px w-10 bg-[#FCD34D]" />
        </div>

        <h2
          data-testid="buildday-final-cta-headline"
          className="reveal text-5xl sm:text-6xl lg:text-7xl xl:text-[6rem] tracking-tighter font-extrabold text-white leading-[0.98]"
        >
          One day. <br />
          <span className="italic font-light text-white">A different you.</span>
        </h2>

        <p className="reveal mt-10 max-w-2xl mx-auto text-base md:text-lg leading-relaxed text-zinc-200 font-medium">
          Most people already know enough to change their life. What they lack
          is{" "}
          <span className="text-white font-semibold">environment</span>,{" "}
          <span className="text-white font-semibold">accountability</span>,{" "}
          <span className="text-white font-semibold">clarity</span> and{" "}
          <span className="text-white font-semibold">execution</span>. The
          Builders Sprint puts all four in one room — for one day — and gives
          you the version of yourself that actually builds.
        </p>

        <div className="reveal mt-12">
          <a
            href="#apply-buildday"
            data-testid="buildday-final-cta-apply-btn"
            className="group inline-flex items-center gap-3 bg-white text-black font-bold text-sm tracking-[0.15em] uppercase px-8 py-5 hover:bg-zinc-200 transition-colors duration-300"
          >
            Reserve Your Spot
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </div>

        <p className="reveal mt-6 text-xs tracking-[0.25em] uppercase text-zinc-400 font-bold">
          One Day · One Room · Limited Spaces
        </p>
      </div>
    </section>
  );
};
